var Buffer = require("../shim/nodeBuffer.js").Buffer;
const config = require("../config.js");
const version = require("../../version.json");
const itemTypes = require("../data/itemTypes.js");
module.exports.keyboardMap = ["", "", "", "CANCEL", "", "", "HELP", "", "BACK_SPACE", "TAB", "", "", "CLEAR", "ENTER", "ENTER_SPECIAL", "", "SHIFT", "CONTROL", "ALT", "PAUSE", "CAPS_LOCK", "KANA", "EISU", "JUNJA", "FINAL", "HANJA", "", "ESCAPE", "CONVERT", "NONCONVERT", "ACCEPT", "MODECHANGE", "SPACE", "PAGE_UP", "PAGE_DOWN", "END", "HOME", "LEFT", "UP", "RIGHT", "DOWN", "SELECT", "PRINT", "EXECUTE", "PRINTSCREEN", "INSERT", "DELETE", "", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "COLON", "SEMICOLON", "LESS_THAN", "EQUALS", "GREATER_THAN", "QUESTION_MARK", "AT", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "OS_KEY", "", "CONTEXT_MENU", "", "SLEEP", "NUMPAD0", "NUMPAD1", "NUMPAD2", "NUMPAD3", "NUMPAD4", "NUMPAD5", "NUMPAD6", "NUMPAD7", "NUMPAD8", "NUMPAD9", "MULTIPLY", "ADD", "SEPARATOR", "SUBTRACT", "DECIMAL", "DIVIDE", "F1", "F2", "F3", "F4", "F5", "F6", "F7", "F8", "F9", "F10", "F11", "F12", "F13", "F14", "F15", "F16", "F17", "F18", "F19", "F20", "F21", "F22", "F23", "F24\t\t", "NUM_LOCK", "SCROLL_LOCK", "WIN_OEM_FJ_JISHO", "WIN_OEM_FJ_MASSHOU", "WIN_OEM_FJ_TOUROKU", "WIN_OEM_FJ_LOYA", "WIN_OEM_FJ_ROYA\t\t", "", "CIRCUMFLEX", "EXCLAMATION", "DOUBLE_QUOTE", "HASH", "DOLLAR", "PERCENT", "AMPERSAND", "UNDERSCORE", "OPEN_PAREN", "CLOSE_PAREN", "ASTERISK", "PLUS", "PIPE", "HYPHEN_MINUS", "OPEN_CURLY_BRACKET", "CLOSE_CURLY_BRACKET", "TILDE\t", "VOLUME_MUTE", "VOLUME_DOWN", "VOLUME_UP", "", "", ";", "=", ",", "MINUS", "PERIOD", "SLASH", "BACK_QUOTE\t\t\t\t\t\t", "", "", "[", "\\", "]", "QUOTE", "", "META", "ALTGR", "", "WIN_ICO_HELP", "WIN_ICO_00", "", ";", "=", ",", "-", ".", "/", "~", "WIN_OEM_PA3", "WIN_OEM_WSCTRL", "WIN_OEM_CUSEL", "WIN_OEM_ATTN", "WIN_OEM_FINISH", "WIN_OEM_COPY", "WIN_OEM_AUTO", "WIN_OEM_ENLW", "WIN_OEM_BACKTAB", "ATTN", "CRSEL", "EXSEL", "EREOF", "PLAY", "ZOOM", "", "PA1", "WIN_OEM_CLEAR", "", "", "", "", "", "", "", "", "[", "\\", "]", "'"];
module.exports.compressNumArray = p3397 => {
  var v3596 = null;
  var v3597 = true;
  for (var v3598 = p3397.length - 1; v3598 >= 0; --v3598) {
    if (typeof p3397[v3598] == "number") {
      if (v3596 === null) {
        v3596 = 0;
      } else {
        v3596++;
        p3397[v3598] = v3596;
        p3397.splice(v3598 + 1);
      }
    } else {
      v3596 = null;
      v3597 = false;
    }
  }
  if (v3597) {
    return p3397[0];
  } else {
    return p3397;
  }
};
module.exports.estKBytes = p3398 => (encodeURI(p3398).split(/%..|./).length - 1) * 0.001;
module.exports.precisionRound = (p3399, p3400, p3401) => {
  p3399 = module.exports.roundNumP(p3399, p3400);
  var v3599 = Math.pow(10, p3400 || 1) / 10;
  if (p3399.countDecimals() == p3400 && !module.exports.isMultiple(p3399, p3401)) {
    p3399 += p3399 * 100 % v3599 > 5 ? p3401 / 2 : -(p3401 / 2);
  }
  return module.exports.roundNumP(p3399, p3400);
};
module.exports.roundNumP = (p3402, p3403) => +(Math.round(p3402 + "e+" + p3403) + "e-" + p3403);
module.exports.isMultiple = (p3404, p3405) => Math.round(p3404 / p3405) / (1 / p3405) === p3404;
Number.prototype.round = function (p3406) {
  return Math.round(this * Math.pow(10, p3406 || 0)) / Math.pow(10, p3406 || 0);
};
String.prototype.escape = function () {
  return (this + "").replace(/[\\"']/g, "\\$&").replace(/\u0000/g, "\\0");
};
module.exports.escapeStr = p3407 => (p3407 + "").replace(/[\\"']/g, "\\$&").replace(/\u0000/g, "\\0");
Number.prototype.ceilToNearest = function (p3408) {
  return Math.ceil(this / p3408) * p3408;
};
Number.prototype.floorToNearest = function (p3409) {
  return Math.floor(this / p3409) * p3409;
};
module.exports.findNearest = (p3410, p3411, p3412) => {
  var v3600;
  var vP3410 = p3410;
  var vP3411 = p3411;
  var v3601 = null;
  var vLN0536 = 0;
  for (var vLN0537 = 0; vLN0537 < p3412.length; vLN0537 += 2) {
    v3600 = module.exports.getDistance(p3410, p3411, p3412[vLN0537], p3412[vLN0537 + 1]);
    if (v3601 == null || v3600 < v3601) {
      v3601 = v3600;
      vP3410 = p3412[vLN0537];
      vP3411 = p3412[vLN0537 + 1];
      vLN0536 = vLN0537;
    }
  }
  return [vP3410, vP3411, vLN0536];
};
module.exports.roundToClos = (p3413, p3414) => p3414 * Math.round(p3413 / p3414);
module.exports.roundToNearest = (p3415, p3416) => p3415 > 0 ? Math.ceil(p3415 / p3416) * p3416 : p3415 < 0 ? Math.floor(p3415 / p3416) * p3416 : parseFloat(p3415);
Number.prototype.roundToNearest = function (p3417) {
  if (this > 0) {
    return Math.ceil(this / p3417) * p3417;
  } else if (this < 0) {
    return Math.floor(this / p3417) * p3417;
  } else {
    return this;
  }
};
Number.prototype.countDecimals = function () {
  if (Math.floor(this.valueOf()) === this.valueOf()) {
    return 0;
  } else {
    return this.toString().split(".")[1].length || 0;
  }
};
module.exports.capFirst = p3418 => p3418.charAt(0).toUpperCase() + p3418.slice(1);
module.exports.isURL = p3419 => {
  try {
    return /^(https?:\/\/)?((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|((\d{1,3}\.){3}\d{1,3}))(\:\d+)?(\/[-a-z\d%@_.~+&:]*)*(\?[;&a-z\d%@_.,~+&:=-]*)?(\#[-a-z\d_]*)?$/i.test(p3419);
  } catch (e19) {}
  return false;
};
module.exports.arrayAverage = p3420 => {
  var vLN0538 = 0;
  for (var vLN0539 = 0; vLN0539 < p3420.length; vLN0539++) {
    vLN0538 += p3420[vLN0539];
  }
  return vLN0538 / p3420.length;
};
module.exports.countInArray = (p3421, p3422) => {
  var vLN0540 = 0;
  for (var vLN0541 = 0; vLN0541 < p3421.length; vLN0541++) {
    if (p3421[vLN0541] === p3422) {
      vLN0540++;
    }
  }
  return vLN0540;
};
module.exports.formatNum = (p3423, p3424 = 1) => {
  if (!p3423) {
    p3423 = 0;
  }
  var v3602 = Math.floor(Math.log(Math.abs(p3423)) / Math.log(1000));
  var v3603 = "kmb"[v3602 - 1];
  if (v3603) {
    return (p3423 / Math.pow(1000, v3602)).toFixed(p3424) + v3603;
  } else {
    return "" + p3423;
  }
};
var vA194 = ["", "k", "m", "b", "t"];
module.exports.formatNumYT = p3425 => {
  var v3604 = p3425 || 0;
  if (p3425 >= 1000) {
    var v3605 = Math.floor(("" + p3425).length / 3);
    var vLS5 = "";
    for (var vLN212 = 2; vLN212 >= 1; vLN212--) {
      vLS5 = parseFloat((v3605 == 0 ? p3425 : p3425 / Math.pow(1000, v3605)).toPrecision(vLN212));
      var v3606 = (vLS5 + "").replace(/[^a-zA-Z 0-9]+/g, "");
      if (v3606.length <= 2) {
        break;
      }
    }
    if (vLS5 % 1 != 0) {
      vLS5 = vLS5.toFixed(1);
    }
    v3604 = vLS5 + vA194[v3605];
  }
  return v3604;
};
module.exports.convCoNum = p3426 => parseFloat(p3426.replace(/,/g, ""));
module.exports.randFloat = (p3427, p3428) => Math.random() * (p3428 - p3427) + p3427;
module.exports.randInt = (p3429, p3430) => Math.floor(Math.random() * (p3430 - p3429 + 1)) + p3429;
module.exports.randInt2 = (p3431, p3432) => Math.sign(Math.random() - 0.5) * (Math.floor(Math.random() * (p3432 - p3431 + 1)) + p3431);
module.exports.getPercentDiff = (p3433, p3434) => Math.round((p3434 - p3433) / p3433 * 100, 1);
module.exports.calcPercent = (p3435, p3436) => p3435 / 100 * p3436;
module.exports.getRandom = p3437 => p3437[module.exports.randInt(0, p3437.length - 1)];
module.exports.getDistance = (p3438, p3439, p3440, p3441) => Math.sqrt((p3440 -= p3438) * p3440 + (p3441 -= p3439) * p3441);
module.exports.getD3D = (p3442, p3443, p3444, p3445, p3446, p3447) => {
  var v3607 = p3442 - p3445;
  var v3608 = p3443 - p3446;
  var v3609 = p3444 - p3447;
  return Math.sqrt(v3607 * v3607 + v3608 * v3608 + v3609 * v3609);
};
module.exports.getObDis = (p3448, p3449) => {
  var v3610 = p3448.x - p3449.x;
  var v3611 = p3448.y - p3449.y;
  var v3612 = p3448.z - p3449.z;
  return Math.sqrt(v3610 * v3610 + v3611 * v3611 + v3612 * v3612);
};
module.exports.getAnglesSSS = (p3450, p3451, p3452) => {
  var v3613 = Math.acos((p3451 * p3451 + p3452 * p3452 - p3450 * p3450) / (p3451 * 2 * p3452));
  var v3614 = Math.acos((p3452 * p3452 + p3450 * p3450 - p3451 * p3451) / (p3452 * 2 * p3450));
  var v3615 = Math.PI - v3613 - v3614;
  return [-v3613 - Math.PI / 2, v3614, v3615];
};
module.exports.getAngleDst = (p3453, p3454) => Math.atan2(Math.sin(p3454 - p3453), Math.cos(p3453 - p3454));
module.exports.getAngleDist2 = (p3455, p3456) => {
  var v3616 = Math.abs(p3456 - p3455) % (Math.PI * 2);
  if (v3616 > Math.PI) {
    return Math.PI * 2 - v3616;
  } else {
    return v3616;
  }
};
module.exports.getXDire = (p3457, p3458, p3459, p3460, p3461, p3462) => {
  var v3617 = Math.abs(p3458 - p3461);
  var v3618 = module.exports.getD3D(p3457, p3458, p3459, p3460, p3461, p3462);
  return Math.asin(v3617 / v3618) * (p3458 > p3461 ? -1 : 1);
};
module.exports.toRad = p3463 => p3463 * (Math.PI / 180);
module.exports.toDeg = p3464 => p3464 * (180 / Math.PI);
module.exports.getDir = (p3465, p3466, p3467, p3468) => Math.atan2(p3466 - p3468, p3465 - p3467);
module.exports.getDrs = (p3469, p3470, p3471) => {
  var v3619 = p3470.x - p3469.x;
  var v3620 = p3470.y + (p3471 || 0) - p3469.y;
  var v3621 = p3470.z - p3469.z;
  var v3622 = Math.sqrt(v3619 * v3619 + v3621 * v3621);
  var v3623 = -Math.atan2(v3620, v3622);
  var v3624 = -Math.atan2(-v3619, v3621);
  return [v3624, v3623];
};
module.exports.lerp = (p3472, p3473, p3474) => p3472 + (p3473 - p3472) * p3474;
module.exports.lerpAngle = (p3475, p3476, p3477) => {
  var v3625 = Math.abs(p3476 - p3475);
  if (v3625 > Math.PI) {
    if (p3475 > p3476) {
      p3476 += Math.PI * 2;
    } else {
      p3475 += Math.PI * 2;
    }
  }
  var v3626 = p3476 + (p3475 - p3476) * p3477;
  if (v3626 >= 0 && v3626 <= Math.PI * 2) {
    return v3626;
  } else {
    return v3626 % (Math.PI * 2);
  }
};
module.exports.orderByDst = (p3478, p3479) => p3478.dst - p3479.dst;
module.exports.orderByDistance = (p3480, p3481) => p3481.distance - p3480.distance;
module.exports.orderByNum = (p3482, p3483) => p3482 - p3483;
module.exports.orderByScore = (p3484, p3485) => p3485.score - p3484.score;
module.exports.orderByKills = (p3486, p3487) => p3487.kills - p3486.kills;
module.exports.capFirst = p3488 => p3488.charAt(0).toUpperCase() + p3488.slice(1);
module.exports.truncateText = (p3489, p3490, p3491, p3492) => module.exports.isNumber(p3490) ? p3489.length > p3490 ? p3491 ? p3489.substring(p3492 || 0, p3490) : p3489.substring(p3492 || 0, p3490) + "..." : p3489 + "" : p3489 + "";
module.exports.replaceText = (p3493, p3494, p3495) => (p3493 + "").replace(p3494 + "", p3495 + "");
module.exports.textContains = (p3496, p3497) => !!(p3496 + "").includes(p3497 + "");
module.exports.cleanseString = p3498 => p3498 ? p3498.replace(/['"]+/g, "") : p3498;
module.exports.randomString = (p3499, p3500) => {
  var vLS6 = "";
  var vLSABCDEFGHIJKLMNOPQRST = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  vLSABCDEFGHIJKLMNOPQRST += p3500 ? "" : "0123456789";
  for (var vLN0542 = 0; vLN0542 < p3499; vLN0542++) {
    vLS6 += vLSABCDEFGHIJKLMNOPQRST.charAt(Math.floor(Math.random() * vLSABCDEFGHIJKLMNOPQRST.length));
  }
  return vLS6;
};
module.exports.formatNumCash = p3501 => parseFloat(Math.round(p3501 * 100) / 100).toFixed(2);
module.exports.formatConstName = p3502 => p3502.toLowerCase().split("_").map(p3503 => p3503.slice(0, 1).toUpperCase() + p3503.slice(1).toLowerCase()).join(" ");
module.exports.getKeyName = p3504 => p3504 < 0 ? "UNBOUND" : p3504 == 20000 ? "SCROLL" : p3504 > 10000 ? "M" + (p3504 - 10000) : module.exports.keyboardMap[p3504];
module.exports.formatNumCash = p3505 => parseFloat(Math.round(p3505 * 100) / 100).toFixed(2);
var vA195 = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
module.exports.getDate = (p3506, p3507) => {
  if (!p3506) {
    return "None";
  }
  p3506 = p3506.split(/[-A-Z :\.]/i);
  var v3627 = new Date(p3506[0], --p3506[1], p3506[2], p3506[3], p3506[4], p3506[5]);
  var v3628 = new Date(v3627.getTime());
  return (p3507 ? v3628.getHours() + ":" + (v3628.getMinutes() + "").padStart(2, "0") + " " : "") + v3628.getDate() + " " + vA195[v3628.getMonth()].slice(0, 3) + " " + v3628.getFullYear();
};
module.exports.getGraphDate = (p3508, p3509, p3510) => ("0" + p3508).slice(-2) + " " + vA195[p3509].slice(0, 3) + (p3510 ? " " + (p3510 + "").slice(-2) : "");
module.exports.getDateTime = () => new Date().toLocaleString();
module.exports.getTime = (p3511, p3512, p3513, p3514 = 100, p3515, p3516 = 1) => {
  if (p3511 == "inf") {
    return "Infinite";
  }
  var v3629 = p3511 % 1000 / p3514;
  v3629 = (p3514 == 1000 ? parseFloat(v3629) : parseInt(v3629)) || 0;
  if (v3629 && p3516) {
    v3629 = v3629.round(p3516);
  }
  if (v3629) {
    v3629 = (v3629 + "").replace("0.", "");
  }
  var vParseInt3 = parseInt(p3511 / 1000 % 60);
  var vParseInt4 = parseInt(p3511 / 60000 % 60);
  var v3630 = Math.floor(p3511 / 3600000 % 24);
  var v3631 = Math.floor(p3511 / 86400000);
  v3631 = v3631 < 10 ? "0" + v3631 : v3631;
  v3630 = p3515 && v3631 && v3630 < 10 ? "0" + v3630 : v3630;
  vParseInt4 = vParseInt4 < 10 ? "0" + vParseInt4 : vParseInt4;
  vParseInt3 = vParseInt3 < 10 ? "0" + vParseInt3 : vParseInt3;
  return (p3515 && v3631 ? v3631 + ":" : "") + (p3513 && (v3630 || v3631) ? v3630 + ":" : "") + (vParseInt4 + ":" + vParseInt3 + (p3512 ? "." + v3629 : ""));
};
module.exports.commaFormatNum = (p3517, p3518) => !p3517 && p3518 ? p3518 : p3517.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
module.exports.commaNumber = p3519 => {
  p3519 = p3519 || 0;
  return p3519.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
module.exports.commaFloat = p3520 => {
  p3520 = p3520 || 0;
  const v3632 = p3520.toString().split(".");
  v3632[0] = module.exports.commaNumber(v3632[0]);
  return v3632.join(".");
};
module.exports.getReadableTime = (p3521, p3522, p3523, p3524) => {
  if (!p3521 && p3523) {
    return p3523;
  }
  var v3633 = Math.floor(p3521 / 1000);
  var v3634 = Math.floor(v3633 / 60);
  v3633 %= 60;
  var v3635 = Math.floor(v3634 / 60);
  v3634 %= 60;
  var v3636 = Math.floor(v3635 / 24);
  v3635 %= 24;
  var v3637 = Math.floor(v3636 / 365);
  v3636 %= 365;
  return (v3637 ? v3637 + "y " : "") + (v3636 ? v3636 + "d " : "") + (v3635 ? v3635 + "h " : "") + (p3524 ? v3634 ? v3634 + "m " : "" : (v3634 ? v3634 : 0) + "m ") + (p3522 ? p3524 ? v3633 ? v3633 + "s " : "" : v3633 + "s" : "");
};
module.exports.getRoundTim = p3525 => {
  var v3638 = p3525 / 1000 | 0;
  var v3639 = v3638 / 60 | 0;
  v3638 -= v3639 * 60;
  var v3640 = v3639 / 60 | 0;
  v3639 -= v3640 * 60;
  var v3641 = v3640 / 24 | 0;
  v3640 -= v3641 * 24;
  if (v3641) {
    return v3641 + " Day" + (v3641 > 1 ? "s " : " ") + (v3640 + " Hour" + (v3640 > 1 ? "s" : ""));
  } else if (v3640) {
    return v3640 + " Hour" + (v3640 > 1 ? "s " : " ") + (v3639 + " Minute" + (v3639 > 1 ? "s" : ""));
  } else {
    return v3639 + " Minute" + (v3639 > 1 ? "s" : "");
  }
};
module.exports.getReadableTime2 = p3526 => {
  if (p3526 < 0) {
    return "just now";
  }
  var v3642 = Math.floor(p3526 / 1000);
  var v3643 = Math.floor(v3642 / 60);
  var v3644 = Math.floor(v3643 / 60);
  v3643 %= 60;
  var v3645 = Math.floor(v3644 / 24);
  v3644 %= 24;
  if (v3645) {
    return v3645 + "d ago";
  } else if (v3644) {
    return v3644 + "h ago";
  } else if (v3643) {
    return v3643 + "m ago";
  } else {
    return "just now";
  }
};
module.exports.getTimeH = p3527 => {
  seconds = Math.floor(p3527 / 1000 % 60);
  minutes = Math.floor(p3527 / 60000 % 60);
  hours = Math.floor(p3527 / 3600000 % 24);
  hours = hours < 10 ? "0" + hours : hours;
  minutes = minutes < 10 ? "0" + minutes : minutes;
  seconds = seconds < 10 ? "0" + seconds : seconds;
  return hours + ":" + minutes + ":" + seconds;
};
module.exports.getChargedTime = p3528 => {
  var vParseInt5 = parseInt(p3528 % 1000 / 100);
  var v3647 = Math.floor(p3528 / 1000 % 60);
  var v3647 = v3647 < 10 ? "0" + v3647 : v3647;
  return v3647 + ":" + vParseInt5;
};
module.exports.scrambleS = p3529 => p3529 && p3529.replace ? p3529.replace(/.(.)?/g, "$1") + ("d" + p3529).replace(/.(.)?/g, "$1") : p3529;
module.exports.fixTo = (p3530, p3531) => parseFloat(p3530.toFixed(p3531));
module.exports.fixFloat = (p3532, p3533) => +parseFloat(p3532).toFixed(p3533);
module.exports.sanitizeStr = p3534 => p3534 && p3534.replace ? p3534.replace(/<|>|&/g, "").replace(/[^\x00-\x7F]/g, "") : p3534;
module.exports.limit = (p3535, p3536) => p3535 < -p3536 ? -p3536 : p3535 > p3536 ? p3536 : p3535;
module.exports.limitMM = (p3537, p3538, p3539) => p3537 < p3538 ? p3538 : p3537 > p3539 ? p3539 : p3537;
module.exports.limitMMD = (p3540, p3541, p3542, p3543) => p3540 < p3541 ? p3543 : p3540 > p3542 ? p3543 : p3540;
module.exports.inRange = (p3544, p3545, p3546) => p3544 >= p3545 && p3544 <= p3546;
module.exports.cropVal = (p3547, p3548) => p3547 <= p3548 && p3547 >= -p3548 ? 0 : p3547;
module.exports.isNumber = p3549 => p3549 !== null && p3549 !== undefined && typeof p3549 == "number" && !isNaN(p3549) && isFinite(p3549);
module.exports.arrayInts = p3550 => {
  for (var vLN0543 = 0; vLN0543 < p3550.length; ++vLN0543) {
    if (!module.exports.isNumber(p3550[vLN0543])) {
      return false;
    }
  }
  return true;
};
module.exports.isArray = p3551 => Array.isArray(p3551);
module.exports.isString = p3552 => p3552 && typeof p3552 == "string";
module.exports.isObject = p3553 => {
  try {
    return p3553 !== null && typeof p3553 == "object" && Array.isArray(p3553) === false;
  } catch (e20) {
    return false;
  }
};
module.exports.isHexColor = p3554 => /^#([0-9A-F]{3}){1,2}$/i.test(p3554);
module.exports.emptyString = p3555 => !p3555 || p3555.length === 0 || /^\s*$/.test(p3555) || !p3555.trim();
module.exports.compareString = (p3556, p3557) => typeof p3556 == "string" && typeof p3557 == "string" && (p3556.toLowerCase().indexOf(p3557.toLowerCase()) >= 0 || p3557.toLowerCase().indexOf(p3556.toLowerCase()) >= 0);
module.exports.shuffleArray = p3558 => {
  for (let v3648 = p3558.length; v3648--;) {
    const v3649 = Math.floor(Math.random() * (v3648 + 1));
    [p3558[v3648], p3558[v3649]] = [p3558[v3649], p3558[v3648]];
  }
  return p3558;
};
module.exports.yateShuffle = p3559 => {
  for (let v3650, v3651 = p3559.length - 1; v3651 > 0; v3651--) {
    v3650 = Math.floor(Math.random() * (v3651 + 1));
    [p3559[v3651], p3559[v3650]] = [p3559[v3650], p3559[v3651]];
  }
};
var vA196 = [];
module.exports.lineInRect = (p3560, p3561, p3562, p3563, p3564, p3565, p3566, p3567, p3568, p3569, p3570, p3571) => {
  var v3652 = (p3566 - p3560) * p3563;
  var v3653 = (p3569 - p3560) * p3563;
  var v3654 = (p3568 - p3562) * p3565;
  var v3655 = (p3571 - p3562) * p3565;
  var v3656 = (p3567 - p3561) * p3564;
  var v3657 = (p3570 - p3561) * p3564;
  var v3658 = Math.max(Math.max(Math.min(v3652, v3653), Math.min(v3654, v3655)), Math.min(v3656, v3657));
  var v3659 = Math.min(Math.min(Math.max(v3652, v3653), Math.max(v3654, v3655)), Math.max(v3656, v3657));
  return !(v3659 < 0) && !(v3658 > v3659) && v3658;
};
module.exports.similar = (p3572, p3573, p3574) => Math.abs(p3572 - p3573) <= (p3574 || 0);
module.exports.pointInBox3D = (p3575, p3576, p3577, p3578, p3579) => {
  p3579 = p3579 || 0;
  return p3575 >= p3578.x - (p3578.width || p3578.w || 0) - p3579 && p3575 <= p3578.x + (p3578.width || p3578.w || 0) + p3579 && p3576 >= p3578.y - (p3578.height || p3578.h || 0) - p3579 && p3576 <= p3578.y + (p3578.height || p3578.h || 0) + p3579 && p3577 >= p3578.z - (p3578.length || p3578.l || 0) - p3579 && p3577 <= p3578.z + (p3578.length || p3578.l || 0) + p3579;
};
module.exports.pointInBox = (p3580, p3581, p3582, p3583, p3584, p3585, p3586) => p3586 ? p3580 >= p3582 && p3580 <= p3584 && p3581 >= p3583 && p3581 <= p3585 : p3580 > p3582 && p3580 < p3584 && p3581 > p3583 && p3581 < p3585;
module.exports.sharePos = (p3587, p3588, p3589) => {
  p3589 = p3589 || 0;
  return Math.abs(p3587.x - p3588.x) <= p3589 && Math.abs(p3587.y - p3588.y) <= p3589 && Math.abs(p3587.z - p3588.z) <= p3589 && Math.abs(p3587.d - p3588.d) <= p3589;
};
module.exports.cdv = {
  x: "width",
  y: "height",
  z: "length"
};
module.exports.boxIntersection = (p3590, p3591, p3592, p3593, p3594) => {
  var v3660 = module.exports.cdv[p3592];
  var v3661 = module.exports.cdv[p3593];
  var v3662 = p3590[p3592] - p3590[v3660] - 0.1;
  var v3663 = p3591[p3592] - p3591[v3660] - 0.1;
  var v3664 = p3590[p3592] + p3590[v3660] + 0.1;
  var v3665 = p3591[p3592] + p3591[v3660] + 0.1;
  var v3666 = p3590[p3593] - p3590[v3661] - 0.1;
  var v3667 = p3591[p3593] - p3591[v3661] - 0.1;
  var v3668 = p3590[p3593] + p3590[v3661] + 0.1;
  var v3669 = p3591[p3593] + p3591[v3661] + 0.1;
  var v3670 = Math.max(v3662, v3663);
  var v3671 = Math.min(v3664, v3665);
  if (v3671 >= v3670) {
    var v3672 = Math.max(v3666, v3667);
    var v3673 = Math.min(v3668, v3669);
    if (v3673 >= v3672) {
      var vA197 = [{
        [p3592]: v3670,
        [p3593]: v3672,
        d: p3594[0]
      }, {
        [p3592]: v3671,
        [p3593]: v3673,
        d: p3594[1]
      }, {
        [p3592]: v3670,
        [p3593]: v3673,
        d: p3594[2]
      }, {
        [p3592]: v3671,
        [p3593]: v3672,
        d: p3594[3]
      }];
      for (var v3674 = vA197.length - 1; v3674 >= 0; --v3674) {
        if (vA197[v3674][p3592] == v3664 && vA197[v3674][p3592] == v3665 || vA197[v3674][p3592] == v3662 && vA197[v3674][p3592] == v3663 || vA197[v3674][p3593] == v3668 && vA197[v3674][p3593] == v3669 || vA197[v3674][p3593] == v3666 && vA197[v3674][p3593] == v3667 || module.exports.pointInBox(vA197[v3674][p3592], vA197[v3674][p3593], v3662, v3666, v3664, v3668) || module.exports.pointInBox(vA197[v3674][p3592], vA197[v3674][p3593], v3663, v3667, v3665, v3669)) {
          vA197[v3674].dontUse = true;
        }
      }
      return vA197;
    }
  }
  return null;
};
module.exports.boxCornerIntersection = (p3595, p3596, p3597, p3598) => {
  var v3675 = module.exports.cdv[p3597];
  var v3676 = module.exports.cdv[p3598];
  var v3677 = p3595[p3597] + p3595[v3675];
  var v3678 = p3596[p3597] + p3596[v3675];
  var v3679 = p3595[p3597] - p3595[v3675];
  var v3680 = p3596[p3597] - p3596[v3675];
  var v3681 = p3595[p3598] + p3595[v3676];
  var v3682 = p3596[p3598] + p3596[v3676];
  var v3683 = p3595[p3598] - p3595[v3676];
  var v3684 = p3596[p3598] - p3596[v3676];
  var vA198 = [{
    [p3597]: v3679,
    [p3598]: v3683,
    d: Math.PI / 2
  }, {
    [p3597]: v3679,
    [p3598]: v3681,
    d: Math.PI
  }, {
    [p3597]: v3677,
    [p3598]: v3683,
    d: 0
  }, {
    [p3597]: v3677,
    [p3598]: v3681,
    d: -Math.PI / 2
  }];
  for (var v3685 = vA198.length - 1; v3685 >= 0; --v3685) {
    vA198[v3685].i = v3685;
    if (!module.exports.pointInBox(vA198[v3685][p3597], vA198[v3685][p3598], v3680, v3684, v3678, v3682, true)) {
      vA198.splice(v3685, 1);
    }
  }
  if (vA198.length) {
    return vA198;
  } else {
    return null;
  }
};
module.exports.getIntersection = (p3599, p3600, p3601) => {
  var v3686 = module.exports.cdv[p3601];
  var v3687 = p3600[p3601] - p3600[v3686];
  var v3688 = p3599[p3601] - p3599[v3686];
  var v3689 = p3599[p3601] + p3599[v3686];
  var v3690 = p3600[p3601] + p3600[v3686];
  var v3691 = Math.max(v3688, v3687);
  var v3692 = Math.min(v3689, v3690);
  if (v3692 >= v3691) {
    var v3693 = (v3692 - v3691) / 2;
    return {
      [p3601]: v3691 + v3693,
      [v3686]: v3693
    };
  }
  return null;
};
module.exports.limitRectVal = (p3602, p3603, p3604) => {
  var v3694 = module.exports.cdv[p3604];
  if (p3602[p3604] - p3602[v3694] < p3603[p3604] - p3603[v3694]) {
    var v3696 = (p3603[p3604] - p3603[v3694] - (p3602[p3604] - p3602[v3694])) / 2;
    p3602[v3694] -= v3696;
    p3602[p3604] += v3696;
  }
  if (p3602[p3604] + p3602[v3694] > p3603[p3604] + p3603[v3694]) {
    var v3696 = (p3602[p3604] + p3602[v3694] - (p3603[p3604] + p3603[v3694])) / 2;
    p3602[p3604] -= v3696;
    p3602[v3694] -= v3696;
  }
};
module.exports.getMaxRect = (p3605, p3606, p3607) => {
  var v3697;
  var v3698;
  var v3699;
  var v3700;
  var v3701 = module.exports.cdv[p3606];
  var v3702 = module.exports.cdv[p3607];
  for (var vLN0544 = 0; vLN0544 < p3605.length; ++vLN0544) {
    v3697 = v3697 == null ? p3605[vLN0544][p3606] - p3605[vLN0544][v3701] : Math.min(p3605[vLN0544][p3606] - p3605[vLN0544][v3701], v3697);
    v3699 = v3699 == null ? p3605[vLN0544][p3606] + p3605[vLN0544][v3701] : Math.max(p3605[vLN0544][p3606] + p3605[vLN0544][v3701], v3699);
    v3698 = v3698 == null ? p3605[vLN0544][p3607] - p3605[vLN0544][v3702] : Math.min(p3605[vLN0544][p3607] - p3605[vLN0544][v3702], v3698);
    v3700 = v3700 == null ? p3605[vLN0544][p3607] + p3605[vLN0544][v3702] : Math.max(p3605[vLN0544][p3607] + p3605[vLN0544][v3702], v3700);
  }
  return {
    [p3606]: (v3697 + v3699) / 2,
    [p3607]: (v3698 + v3700) / 2,
    [v3701]: Math.abs(v3699 - v3697) / 2,
    [v3702]: Math.abs(v3700 - v3698) / 2
  };
};
module.exports.limitRect = (p3608, p3609, p3610, p3611, p3612, p3613, p3614, p3615) => {
  var v3703 = module.exports.getMaxRect(p3613, p3614, p3615);
  var v3704 = module.exports.cdv[p3614];
  var v3705 = module.exports.cdv[p3615];
  var vO105 = {
    [p3614]: p3608,
    [p3615]: p3609,
    [v3705]: p3611,
    [v3704]: p3610
  };
  module.exports.limitRectVal(vO105, v3703, p3614);
  module.exports.limitRectVal(vO105, v3703, p3615);
  if (p3612 == 0 || p3612 == Math.PI) {
    var v3706 = vO105[v3704];
    vO105[v3704] = vO105[v3705];
    vO105[v3705] = v3706;
  }
  return vO105;
};
module.exports.progressOnLine = (p3616, p3617, p3618, p3619, p3620, p3621) => {
  var v3707 = p3618 - p3616;
  var v3708 = p3619 - p3617;
  var v3709 = Math.sqrt(v3707 * v3707 + v3708 * v3708);
  v3707 /= v3709;
  v3708 /= v3709;
  return (v3707 * (p3620 - p3616) + v3708 * (p3621 - p3617)) / Math.sqrt(Math.pow(p3618 - p3616, 2) + Math.pow(p3619 - p3617, 2));
};
module.exports.generateSID = p3622 => {
  var vLN0545 = 0;
  for (var v3710 = true; v3710;) {
    v3710 = false;
    vLN0545++;
    for (var vLN0546 = 0; vLN0546 < p3622.length; ++vLN0546) {
      if (p3622[vLN0546].sid == vLN0545) {
        v3710 = true;
        break;
      }
    }
  }
  return vLN0545;
};
module.exports.levelIconId = p3623 => Math.max(Math.min(config.maxLevel - 1, p3623.roundToNearest(2) - 1), 0);
const vF3 = p3624 => p3624.level > 1 ? Math.pow(p3624.level / config.rankVar, 2) : 0;
const vF4 = p3625 => parseInt(p3625.score - vF3(p3625));
module.exports.currentXp = vF4;
const vF5 = p3626 => parseInt(Math.pow((p3626.level + 1) / config.rankVar, 2) - vF3(p3626));
module.exports.xpToNextLevel = vF5;
module.exports.xpBarText = p3627 => vF4(p3627) + " / " + vF5(p3627);
module.exports.copyToClipboard = p3628 => {
  const v3711 = document.createElement("textarea");
  v3711.value = p3628;
  v3711.setAttribute("readonly", "");
  v3711.style.position = "absolute";
  v3711.style.left = "-9999px";
  document.body.appendChild(v3711);
  const v3712 = !!(document.getSelection().rangeCount > 0) && document.getSelection().getRangeAt(0);
  v3711.select();
  document.execCommand("copy");
  document.body.removeChild(v3711);
  if (v3712) {
    document.getSelection().removeAllRanges();
    document.getSelection().addRange(v3712);
  }
};
var vF6 = (p3629, p3630) => p3629.concat(p3630);
var vF7 = (p3631, p3632) => p3632.map(p3631).reduce(vF6, []);
Array.prototype.flatMap = function (p3633) {
  return vF7(p3633, this);
};
const msgpack = require("msgpack-lite");
const {
  Encoder,
  Decoder
} = msgpack;
const v3713 = new Encoder();
const v3714 = new Decoder();
var vLN213 = 2;
// NOTE: msgpack-lite's Encoder#encode / Decoder#decode return undefined;
// they only emit a "data" event. Use the static encode/decode which return
// the encoded buffer / decoded value directly.
module.exports.serializePacket = (p3634, ...iìiiîii) => msgpack.encode([p3634, ...iìiiîii]);
module.exports.encodePacket = (p3635, p3636) => {
  let v3715 = new Uint8Array(p3635.length + vLN213);
  v3715.set(module.exports.encodeShort(p3636), v3715.length - 2);
  v3715.set(p3635, 0);
  return v3715;
};
module.exports.shouldUpdate = (p3637, p3638, p3639) => p3637 % (p3638 / p3639) == 0;
module.exports.decodePacket = p3640 => {
  p3640 = new Uint8Array(p3640);
  let v3716 = module.exports.decodeShort(p3640[p3640.length - 2], p3640[p3640.length - 1]);
  let v3717 = p3640.slice(0, p3640.length - vLN213);
  let v3718 = msgpack.decode(v3717);
  if (!Array.isArray(v3718) || v3718.length < 1) {
    throw "Invalid message";
  }
  let v3719 = v3718[0];
  let v3720 = v3718.slice(1);
  return [v3716, v3719, v3720];
};
module.exports.rotateNumber = (p3641, p3642) => p3641 + p3642 & 255;
module.exports.encodeShort = p3643 => [p3643 >> 4 & 15, p3643 & 15];
module.exports.decodeShort = (p3644, p3645) => (p3644 << 4) + p3645;
module.exports.thumbnailSize = p3646 => parseInt(p3646.replace(/=/g, "").length * 0.75) / 1000;
module.exports.rgbToHex = (p3647, p3648, p3649) => {
  for (var v3721 = (p3647 << 16 | p3648 << 8 | p3649).toString(16); v3721.length < 6;) {
    v3721 = "0" + v3721;
  }
  return "#" + v3721;
};
module.exports.hexToRGB = p3650 => p3650.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (p3651, p3652, p3653, p3654) => "#" + p3652 + p3652 + p3653 + p3653 + p3654 + p3654).substring(1).match(/.{2}/g).map(p3655 => parseInt(p3655, 16));
module.exports.hexFromHue = p3656 => {
  var v3722 = p3656 / 60;
  var v3723 = (1 - Math.abs(v3722 % 2 - 1)) * 255;
  var v3724 = Math.floor(v3722);
  return module.exports.rgbToHex(v3724 < 1 || v3724 > 4 ? 255 : v3724 == 1 || v3724 == 4 ? v3723 : 0, v3724 == 0 || v3724 == 3 ? v3723 : v3724 == 1 || v3724 == 2 ? 255 : 0, v3724 == 0 || v3724 == 1 ? 0 : v3724 == 3 || v3724 == 4 ? 255 : v3723);
};
module.exports.invertHex = p3657 => {
  p3657 = (p3657 + "").replace("#", "");
  return "#" + (+("0x1" + p3657) ^ 16777215).toString(16).substr(1).toUpperCase();
};
module.exports.versionifyUrl = p3658 => p3658 + "?build=" + version;
module.exports.assetsUrl = (p3659, p3660, p3661) => {
  if (!p3660 && p3659.startsWith("/")) {
    p3659 = p3659.slice(1);
  }
  return this.versionifyUrl(p3661 ? "./" + p3659 : "https://assets.krunker.io/" + p3659);
};
module.exports.userAssetsUrl = (v3725, p3663, p3664, p3665) => {
  if (!p3663 && v3725.startsWith("/")) {
    v3725 = v3725.slice(1);
  }
  var v3725 = "https://user-assets.krunker.io/" + v3725;
  if (p3665) {
    return this.versionifyUrl(v3725);
  } else {
    return v3725;
  }
};
module.exports.getSkinsFromCreator = (p3666, p3667) => p3667.skins.filter(p3668 => !!p3668.creators && p3668.creators.indexOf(p3666.toLowerCase()) > -1);
module.exports.canUseSkin = (p3669, p3670, p3671, p3672, p3673, p3674) => {
  var v3726 = p3670[p3669];
  return !!v3726 && (!!p3671 && !!p3671.isDev || (!p3673 || v3726.weapon == null || p3673.id == v3726.weapon - 1) && (p3674 == null || p3674 == v3726.type) && (p3674 != 12 || !!p3673 && !!p3673.charm) && (!!v3726.kpd && !!p3671 && (!!p3671.isMod || !!p3671.isDeputy) || (v3726.classIndex == null || v3726.classIndex == p3672) && (!!v3726.creators && !!p3671 && !!(v3726.creators.indexOf((p3671.name || "").toLowerCase()) > -1) || !!v3726.streamers && !!p3671 && !!p3671.twitch && !!(v3726.streamers.indexOf((p3671.twitch || "").toLowerCase()) > -1) || !!v3726.free || !v3726.creator && !!((v3726.seas || 0) >= 6) && !!p3671 && !!p3671.isSkinMaker && !v3726.blocked || p3671 && p3671.hasSkin(p3669))));
};
module.exports.isFreeSkin = (p3675, p3676) => {
  var v3727 = p3676[p3675];
  return !!v3727 && !!v3727.free;
};
module.exports.getPreview = (p3677, p3678) => module.exports.assetsUrl("/textures/" + (p3677.type && (p3677.type == itemTypes.PLAYER_CARD || p3677.type == itemTypes.SPRAY) ? p3678.types[p3677.type] + p3677.id : "previews/" + (p3677.type && p3677.type != itemTypes.MELEE ? "cosmetics/" + (p3677.assetType || p3677.type) + "_" + p3677.id + (p3677.tex ? "_" + p3677.tex : "") : p3678.types[p3677.assetType || p3677.type || 0] + (p3677.type && p3677.type == itemTypes.MELEE ? p3677.id + (p3677.pat == null ? p3677.tex == null ? "" : "_" + p3677.tex : "_c" + p3677.pat) : (p3677.weapon || 0) + "_" + (p3677.mid == null ? p3677.pat == null ? p3677.tex ? p3677.tex : p3677.id : "c" + p3677.pat : "m" + p3677.mid + (p3677.midT == null ? "" : "_" + p3677.midT))))) + "." + (p3677.texExt || "png"), false, p3677.local);
module.exports.getPreviewExport = p3679 => p3679.thumbnail.split("/").slice(-1).pop().split("?")[0];
module.exports.getReModel = (p3680, p3681) => p3680.types[p3681.assetType || p3681.type || 0] + (p3681.weapon || 0) + "_" + (p3681.midT || p3681.mid);
module.exports.getFrameAnim = (p3682, p3683) => p3682.frames ? "animation: " + p3683 + p3682.frames + " " + (1 + p3682.frameT / 1000) + "s steps(" + p3682.frames + ") infinite;" : "";
module.exports.isDropbox = p3684 => /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?(dropbox|dropboxusercontent|dl\.dropboxusercontent)\.com\//g.test(p3684);
module.exports.isUserAsset = p3685 => /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?(user-assets\.krunker)\.io\//g.test(p3685) || /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?(krunker-user-assets\.nyc3\.cdn\.digitaloceanspaces)\.com\//g.test(p3685) || /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?(krunker-user-assets\.nyc3\.digitaloceanspaces)\.com\//g.test(p3685) || /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?(storage\.googleapis\.com\/user-assets.krunker)\.io\//g.test(p3685);
module.exports.replaceUserAsset = p3686 => {
  p3686 = p3686.replace("krunker-user-assets.nyc3.cdn.digitaloceanspaces.com", "user-assets.krunker.io").replace("krunker-user-assets.nyc3.digitaloceanspaces.com", "user-assets.krunker.io");
  return p3686;
};
module.exports.toSocial = p3687 => "./social.html?p=profile&q=" + module.exports.cleanseString(p3687);
module.exports.getFontSizeToFit = (p3688, p3689, p3690) => {
  var v3728 = document.createElement("canvas").getContext("2d");
  v3728.font = "1px " + p3689;
  return p3690 / v3728.measureText(p3688).width;
};
module.exports.ctxText = (p3691, p3692, p3693, p3694, p3695, p3696, p3697, p3698, p3699) => {
  p3691.save(1);
  p3691.translate(~~p3694, ~~p3695);
  if (p3697) {
    p3691.font = p3697 + "px GameFont";
  }
  p3691.fillStyle = p3693;
  if (p3696) {
    p3691.textAlign = p3696;
  }
  p3691.strokeStyle = p3698 || "#626262";
  p3691.lineWidth = p3699 || 1;
  p3691.miterLimit = 2;
  p3691.lineJoin = "round";
  p3691.strokeText(p3692, 0, 0);
  p3691.fillText(p3692, 0, 0);
  p3691.restore(-1);
};
module.exports.getLines = (p3700, p3701, p3702) => {
  for (var v3729 = p3701.split(" "), vA199 = [], v3730 = v3729[0], vLN148 = 1; vLN148 < v3729.length; vLN148++) {
    var v3731 = v3729[vLN148];
    var v3732 = p3700.measureText(v3730 + " " + v3731).width;
    if (v3732 < p3702) {
      v3730 += " " + v3731;
    } else {
      vA199.push(v3730);
      v3730 = v3731;
    }
  }
  vA199.push(v3730);
  return vA199;
};
module.exports.createCanvasText = (p3703, p3704, p3705, p3706, p3707, p3708, p3709, p3710, p3711, p3712, p3713) => {
  var vLN0547 = 0;
  var vLN0548 = 0;
  if (p3704 > p3703) {
    vLN0547 = 1;
    vLN0548 = p3703 / p3704;
  } else if (p3704 < p3703) {
    vLN0547 = p3704 / p3703;
    vLN0548 = 1;
  } else {
    vLN0547 = 1;
    vLN0548 = 1;
  }
  var v3733 = document.createElement("canvas");
  var v3734 = v3733.getContext("2d");
  var vLN10243 = 1024;
  v3733.width = vLN10243 * vLN0548;
  v3733.height = vLN10243 * vLN0547;
  if (!p3709) {
    v3734.fillStyle = p3708;
    v3734.fillRect(0, 0, v3733.width, v3733.height);
  }
  var vP3706 = p3706;
  if (p3713) {
    vP3706 *= Math.min(vLN10243 / p3703, vLN10243 / p3704);
  }
  v3734.font = vP3706 + "px GameFont";
  p3705 = p3705.substring(0, config.signTextLimit - 1);
  v3734.textAlign = p3710 == 2 ? "right" : p3710 == 1 ? "center" : "left";
  var v3735 = vP3706 * 2;
  var v3736 = v3734.measureText("M").width / 2;
  v3736 = p3710 == 2 ? v3733.width - v3736 : p3710 == 1 ? v3733.width / 2 : v3736;
  var v3737 = v3734.measureText("M").width * 1.2;
  for (var v3738 = p3705.split("\\n"), v3739 = null, vLN0549 = 0; vLN0549 < v3738.length; ++vLN0549) {
    v3739 = module.exports.getLines(v3734, v3738[vLN0549], v3733.width - vP3706);
    for (var vLN0550 = 0; vLN0550 < v3739.length && (module.exports.ctxText(v3734, v3739[vLN0550], p3707, v3736, v3735, null, null, p3711, p3712), v3735 += v3737, !(v3735 > v3733.height)); ++vLN0550) {
      ;
    }
  }
  return v3733;
};
module.exports.createLeaderText = (p3714, p3715, p3716, p3717) => {
  var vLN0551 = 0;
  var vLN0552 = 0;
  if (p3715 > p3714) {
    vLN0551 = 1;
    vLN0552 = p3714 / p3715;
  } else if (p3715 < p3714) {
    vLN0551 = p3715 / p3714;
    vLN0552 = 1;
  } else {
    vLN0551 = 1;
    vLN0552 = 1;
  }
  var v3740 = document.createElement("canvas");
  var v3741 = v3740.getContext("2d");
  var vLN10244 = 1024;
  v3740.width = vLN10244 * vLN0552;
  v3740.height = vLN10244 * vLN0551;
  var v3742 = p3717.fcolr || "#000";
  var v3743 = p3717.bcolr || "#fff";
  if (!p3717.noBVis) {
    v3741.fillStyle = v3743;
    v3741.fillRect(0, 0, v3740.width, v3740.height);
  }
  var v3744 = p3717.fontSize || 10;
  if (p3717.noSCF) {
    v3744 *= Math.min(vLN10244 / p3714, vLN10244 / p3715);
  }
  v3741.font = v3744 + "px GameFont";
  v3741.textAlign = "left";
  var v3745 = v3744 * 2;
  var v3746 = v3741.measureText("M").width / 2;
  var v3747 = v3741.measureText("M").width * 1.2;
  module.exports.ctxText(v3741, "Player", v3742, v3746, v3745, "left", v3744 * 1.25);
  module.exports.ctxText(v3741, module.exports.capFirst(p3717.leaderType), v3742, v3740.width - v3746, v3745, "right", v3744 * 1.25);
  v3745 = v3744 * 1.25 * 2;
  v3741.fillStyle = v3742;
  v3741.fillRect(0, v3745, v3740.width, v3744 / 3);
  v3745 += v3744 * 2;
  for (var vLN0553 = 0; vLN0553 < p3716.length; vLN0553 += 2) {
    module.exports.ctxText(v3741, 1 + vLN0553 / 2 + ". " + p3716[vLN0553], v3742, v3746, v3745, "left");
    var v3748 = p3716[vLN0553 + 1];
    if ((p3717.leaderType + "").toLowerCase() == "time") {
      v3748 = module.exports.getTime(v3748, true, parseInt(v3748) >= 3600000, 1, parseInt(v3748) >= 86400000);
    }
    module.exports.ctxText(v3741, v3748, v3742, v3740.width - v3746, v3745, "right");
    v3745 += v3747;
    if (v3745 > v3740.height) {
      break;
    }
  }
  return v3740;
};
module.exports.createCanvasAD = (p3718, p3719, p3720, p3721) => {
  var v3749 = document.createElement("canvas");
  var v3750 = (p3721 || 1) * 1024;
  v3749.width = v3750 * 2;
  v3749.height = v3750 * 1;
  var v3751 = v3749.getContext("2d");
  v3751.fillStyle = p3720 || "#000000";
  v3751.fillRect(0, 0, v3749.width, v3749.height);
  module.exports.drawMultilineText(v3751, p3718, p3719, v3749.width, v3749.height, p3721 || 1);
  return v3749;
};
module.exports.drawMultilineText = (p3722, p3723, p3724, p3725, p3726, p3727) => {
  var v3760;
  var v3753 = (module.exports.isString(p3723) ? p3723 : "Your Ad Here").split(" ");
  var vA200 = [];
  var vLN0554 = 0;
  var v3754 = (p3727 || 1) * 80;
  var vLN149 = 1.4;
  for (var v3755 = (p3727 || 1) * 15; v3755 <= (p3727 || 1) * 2000; v3755++) {
    v3760 = v3755 * vLN149;
    p3722.font = v3755 + "px GameFont";
    var v3761 = (p3725 - v3754) / 2;
    var v3762 = v3760;
    var vA201 = [];
    var v3757 = v3753[0];
    if (p3722.measureText(v3757).width > p3725 - v3754) {
      vLN0554 = v3755 - 1;
      break;
    }
    for (var vLN0555 = 1; vLN0555 < v3753.length; vLN0555++) {
      var v3758 = v3753[vLN0555];
      var v3759 = p3722.measureText(v3757 + " " + v3758).width;
      if (v3759 < p3725 - v3754) {
        v3757 += " " + v3758;
      } else {
        vA201.push(v3757);
        v3757 = v3758;
        v3762 += v3760;
      }
    }
    vA201.push(v3757);
    if (v3762 > p3726 - v3754) {
      vLN0554 = v3755 - 1;
      break;
    } else {
      vA200 = vA201;
      vLN0554 = v3755;
    }
  }
  var v3760 = v3755 * vLN149;
  var v3761 = p3725 / 2;
  var v3762 = p3726 / 2;
  if (vA200.length > 1) {
    v3762 -= v3760 * (vA200.length - 1) / 2;
  }
  v3761 += v3754 / 2 / vA200.length;
  v3762 += v3754 / vA200.length;
  p3722.font = vLN0554 + "px GameFont";
  p3722.fillStyle = p3724 || "#e3e3e3";
  p3722.strokeStyle = "rgba(0, 0, 0, 0.5)";
  p3722.lineWidth = 1;
  for (var vLN0555 = 0; vLN0555 < vA200.length; vLN0555++) {
    p3722.strokeText(vA200[vLN0555].trim(), v3761 - p3722.measureText(vA200[vLN0555].trim()).width / 2, v3762 + v3755 / 2);
    p3722.fillText(vA200[vLN0555].trim(), v3761 - p3722.measureText(vA200[vLN0555].trim()).width / 2, v3762 + v3755 / 2);
    v3762 += v3760;
  }
  return v3755;
};
module.exports.extractProperties = (p3728, p3729) => p3729.reduce((p3730, p3731) => {
  p3730[p3731] = p3728[p3731];
  return p3730;
}, {});
module.exports.calcVoteNum = p3732 => p3732.level >= 50 ? 1.5 : 1;
module.exports.getMsgType = p3733 => p3733.kicked ? 2 : p3733.banned ? 3 : p3733.kickedByVote ? 4 : p3733.arrested ? 5 : 1;
module.exports.getAccountType = p3734 => p3734 && p3734.featured ? 3 : p3734 && p3734.premiumT ? 2 : p3734 ? 1 : 0;
module.exports.sortItems = (p3735, p3736) => p3735.sort(function (p3737, p3738) {
  var v3763 = p3736[p3738.i || p3738.ind] ? p3736[p3738.i || p3738.ind].rarity : 0;
  var v3764 = p3736[p3737.i || p3737.ind] ? p3736[p3737.i || p3737.ind].rarity : 0;
  var v3765 = p3736[p3738.i || p3738.ind] ? p3736[p3738.i || p3738.ind].seas || 1 : 0;
  var v3766 = p3736[p3737.i || p3737.ind] ? p3736[p3737.i || p3737.ind].seas || 1 : 0;
  if (v3763 > v3764) {
    return 1;
  } else if (v3763 < v3764) {
    return -1;
  } else if (v3765 > v3766) {
    return 1;
  } else if (v3765 < v3766) {
    return -1;
  } else {
    return (p3738.i || p3738.ind || 0) - (p3737.i || p3737.ind || 0);
  }
});
module.exports.splitIds = p3739 => p3739 ? p3739.split(",").filter(p3740 => p3740.length).map(Number) : [];
module.exports.fixStr = p3741 => p3741 ? config.invisChar + p3741 + config.invisChar : "";
module.exports.cleanName = p3742 => p3742 ? p3742.replace("'", "\\'").replace("\"", "\\\"") : "";
module.exports.filterTwitch = p3743 => p3743 ? p3743.replace(/[^\w]/gmi, "").substring(0, 25) : "";
module.exports.filterYoutube = p3744 => p3744 ? p3744.replace(/[^\w_-]/gmi, "").substring(0, 11) : "";
module.exports.replaceYoutubeLinks = p3745 => {
  try {
    return (p3745 || "").replace(/yt-/gmi, "").replace(/(?:https?:)?(?:\/\/)?(?:[0-9A-Z-]+\.)?(?:youtu\.be\/|youtube(?:-nocookie)?\.com\S*?[^\w\s-])([\w-]{11})(?=[^\w-]|$)(?![?=&+%\w.-]*(?:['"][^<>]*>|<\/a>))[?=&+%\w.-]*/im, "yt-$1").replace(/(?:https?:)?(?:\/\/)?(?:[0-9A-Z-]+\.)?(?:youtu\.be\/|youtube(?:-nocookie)?\.com\S*?[^\w\s-])([\w-]{11})(?=[^\w-]|$)(?![?=&+%\w.-]*(?:['"][^<>]*>|<\/a>))[?=&+%\w.-]*/gim, "");
  } catch (e21) {
    return p3745 || "";
  }
};
module.exports.createEmbedFromStr = p3746 => {
  try {
    p3746 = p3746 || "";
    var v3767 = /yt-([\w_-]{11})/gmi.exec(p3746);
    if (v3767) {
      p3746 = p3746.replace(v3767[0], "<iframe src=\"https://www.youtube.com/embed/" + v3767[1] + "\" style=\"margin-top:10px;margin-bottom:5px;width:100%;border:none;height:300px;\"></iframe>");
    }
    return p3746;
  } catch (e22) {
    return p3746 || "";
  }
};
module.exports.convertFaces = (p3747, p3748) => p3748 ? parseInt(p3747.join(""), 2).toString(16) : parseInt(p3747, 16).toString(2).padStart(6, "0").split("").map(Number);
module.exports.parseColor = p3749 => parseInt(p3749.slice(1), 16);
module.exports.stringifyColor = p3750 => "#" + ("000000" + p3750.toString(16)).substr(-6);
module.exports.getObjKeys = (p3751, p3752 = []) => {
  let v3768 = Object.keys(p3751);
  if (!v3768.length) {
    return [null];
  }
  let v3769 = v3768.filter(p3753 => !p3752.includes(p3753)).map(p3754 => module.exports.getObjKeys(p3751[p3754], p3752).map(p3755 => p3755 ? p3754 + "|" + p3755 : p3754));
  if (v3769.length) {
    return v3769.reduce((p3756, p3757) => [...p3756, ...p3757]);
  } else {
    return [null];
  }
};
module.exports.removePrivateKeys = p3758 => {
  let vO106 = {};
  Object.keys(p3758).filter(p3759 => !p3759.startsWith("_")).forEach(p3760 => vO106[p3760] = p3758[p3760]);
  return vO106;
};
module.exports.loadImage = p3761 => new Promise(p3762 => {
  let v3770 = new Image();
  v3770.onload = () => {
    p3762(v3770);
  };
  v3770.src = p3761;
});
module.exports.easeinout = p3763 => -(Math.cos(Math.PI * p3763) - 1) / 2;
module.exports.padArray = (p3764, p3765, p3766) => [...p3764, ...Array(p3766).fill(1).map(() => p3765)].slice(0, p3766);
const vA202 = [undefined, "social.market.hat", "social.market.body", "social.market.melee", "social.market.spray", "social.market.dye", "social.market.waist", "social.market.face", "social.market.shoe", "social.market.pet", "social.market.collectible", "social.market.wrist", "social.market.charm", "social.market.ticket", "social.market.back", "social.market.head", "social.market.playerCard"];
module.exports.getItemDescMobile = (p3767, p3768) => vA202[p3767.type] ? {
  locale: vA202[p3767.type]
} : {
  desc: p3768[p3767.weapon - 1].name
};
module.exports.getItemDesc = (p3769, p3770, p3771) => vA202[p3769.type] ? p3771.get(vA202[p3769.type]) : p3770[p3769.weapon - 1].name;
module.exports.getMeleeConfig = (p3772, p3773, p3774) => {
  var v3771 = p3773.skins[p3772];
  if (!v3771) {
    v3771 = {};
  }
  return {
    fileExt: v3771.fileExt,
    animS: v3771.animS,
    hasAnim: v3771.hasAnim,
    local: v3771.local,
    localM: v3771.localM,
    src: "melee/melee_" + (v3771.id || 0),
    texSrc: v3771.pat ? v3771.tex : v3771.tex ? "melee/melee_" + (v3771.id || 0) + "_" + v3771.tex : "",
    sameEnv: v3771.sameEnv,
    env: v3771.env || v3771.sameEnv ? v3771.env || 3 : undefined,
    sameGlow: v3771.sameGlow,
    glowText: v3771.glow || v3771.sameGlow,
    emissive: v3771.glow || v3771.sameGlow ? "#ffffff" : null,
    movT: v3771.movT,
    movE: v3771.movE,
    movD: v3771.movD,
    pulsT: v3771.pulsT,
    minGlo: v3771.minGlo,
    frameT: v3771.frameT,
    tFilter: p3774.LinearFilter,
    frames: v3771.frames,
    transparent: v3771.opac != null,
    mat: p3774.MeshLambertMaterial,
    uv2: true,
    specular: 2697513,
    shininess: 100,
    rgb: v3771.rgb,
    rgbS: v3771.rgbS,
    rgbT: v3771.rgbT,
    useWireframe: v3771.wire,
    side: v3771.side || 0,
    opacity: v3771.opac || 1,
    alphaTest: v3771.alpha || 0,
    shaderNum: v3771.shaderNum,
    video: v3771.video,
    projection: v3771.projection
  };
};
module.exports.getMeshGroupIndex = (p3775, p3776) => {
  var v3772 = p3776 && !p3775.forceTex ? "default" : p3775.src;
  return (v3772 + "-" + (p3775.shadowsR || "a") + (p3775.emissive || "e") + (p3775.opacity || "o") + (p3775.movT == null ? "mt" : p3775.movT) + (p3775.movD == null ? "md" : p3775.movD) + (p3775.texOffX || "tx") + (p3775.texOffY || "ty") + (p3775.texRot || "tr") + (p3775.normal || "n") + (p3775.specular || "spc") + (p3775.asset || "as") + (p3775.itemID || "id") + (p3775.noFog == null ? "" : "nf") + (p3775.frames == null ? "" : "fr" + p3775.frames) + (p3775.frameT == null ? "" : "frt" + p3775.frameT) + (p3775.rside == null ? "" : "side_" + p3775.rside) + (p3775.fTrans ? "fT" : "")).replace(/\./gm, "").toLowerCase();
};
module.exports.moveElement = (p3777, p3778) => {
  var v3773 = document.createDocumentFragment();
  v3773.appendChild(p3777);
  document.getElementById(p3778).appendChild(v3773);
};
if (!String.prototype.replaceAll) {
  const vF8 = (p3779, p3780, p3781) => {
    if (p3781 == null || p3779 == null || p3780 == null) {
      throw TypeError("Input values must not be `null` or `undefined`");
    }
  };
  const vF10 = (p3782, p3783) => {
    if (typeof p3782 != "string" && !(p3782 instanceof String)) {
      throw TypeError("`" + p3783 + "` must be a string");
    }
  };
  const vF11 = p3784 => {
    if (typeof p3784 != "string" && !(p3784 instanceof String) && !(p3784 instanceof RegExp)) {
      throw TypeError("`searchValue` must be a string or an regexp");
    }
  };
  const vF12 = (p3785, p3786, p3787) => {
    if (p3785 === "") {
      return p3787.replace(/(?:)/g, p3786);
    }
    if (p3785 instanceof RegExp) {
      if (p3785.flags.indexOf("g") === -1) {
        throw TypeError("`.replaceAll` does not allow non-global regexes");
      }
      return p3787.replace(p3785, p3786);
    }
    return p3787.split(p3785).join(p3786);
  };
  String.prototype.replaceAll = function (p3788, p3789) {
    var vThis25 = this;
    vF8(p3788, p3789, vThis25);
    vF10(vThis25, "str");
    vF10(p3789, "replaceValue");
    vF11(p3788);
    return vF12(p3788, p3789, vThis25);
  };
}
module.exports.VectorDot = (p3790, p3791) => p3790.x * p3791.x + p3790.y * p3791.y + p3790.z * p3791.z;
module.exports.VectorLength = p3792 => Math.sqrt(p3792.x * p3792.x + p3792.y * p3792.y + p3792.z * p3792.z);
module.exports.VectorNormalize = p3793 => {
  var v3774 = module.exports.VectorLength(p3793) || 1;
  p3793.x *= 1 / v3774;
  p3793.y *= 1 / v3774;
  p3793.z *= 1 / v3774;
  return p3793;
};
module.exports.VectorInvert = p3794 => {
  p3794.x *= -1;
  p3794.y *= -1;
  p3794.z *= -1;
  return p3794;
};
module.exports.VectorMultiplyScalar = (p3795, p3796, p3797 = false) => {
  var vO107 = {
    x: p3795.x,
    y: p3795.y,
    z: p3795.z
  };
  if (p3797) {
    vO107.x *= p3796;
    vO107.y *= p3796;
    vO107.z *= p3796;
  } else {
    p3795.x *= p3796;
    p3795.y *= p3796;
    p3795.z *= p3796;
  }
  if (p3797) {
    return vO107;
  } else {
    return p3795;
  }
};
module.exports.VectorAdd = (p3798, p3799, p3800 = false) => {
  var vO108 = {
    x: p3798.x,
    y: p3798.y,
    z: p3798.z
  };
  if (p3800) {
    vO108.x += p3799.x;
    vO108.y += p3799.y;
    vO108.z += p3799.z;
  } else {
    p3798.x += p3799.x;
    p3798.y += p3799.y;
    p3798.z += p3799.z;
  }
  if (p3800) {
    return vO108;
  } else {
    return p3798;
  }
};
module.exports.VectorSub = (p3801, p3802, p3803 = false) => {
  var vO109 = {
    x: p3801.x,
    y: p3801.y,
    z: p3801.z
  };
  if (p3803) {
    vO109.x -= p3802.x;
    vO109.y -= p3802.y;
    vO109.z -= p3802.z;
  } else {
    p3801.x -= p3802.x;
    p3801.y -= p3802.y;
    p3801.z -= p3802.z;
  }
  if (p3803) {
    return vO109;
  } else {
    return p3801;
  }
};
module.exports.VectorReflect = (p3804, p3805) => module.exports.VectorSub(p3804, module.exports.VectorMultiplyScalar(p3805, module.exports.VectorDot(p3804, p3805, true) * 2, true));
module.exports.Sign = p3806 => p3806 < 0 ? -1 : p3806 > 0 ? 1 : 0;
module.exports.VectorAngleSign = (p3807, p3808) => module.exports.Sign(p3807.x * p3808.z - p3807.z * p3808.x);
module.exports.VectorNorm = p3809 => Math.sqrt(module.exports.VectorDot(p3809, p3809));
module.exports.TransformDirection = (p3810, p3811) => {
  var v3775 = p3810.x;
  var v3776 = p3810.y;
  var v3777 = p3810.z;
  p3810.x = p3811[0] * v3775 + p3811[4] * v3776 + p3811[8] * v3777;
  p3810.y = p3811[1] * v3775 + p3811[5] * v3776 + p3811[9] * v3777;
  p3810.z = p3811[2] * v3775 + p3811[6] * v3776 + p3811[10] * v3777;
  return p3810;
};
module.exports.AngleDiffToPixelDiff = (p3812, p3813, p3814) => p3812 * (p3814 / 2) * p3813 / Math.PI;
module.exports.AngleToPixel = (p3815, p3816, p3817) => p3817 / 2 - 0.5 + module.exports.AngleDiffToPixelDiff(p3815, p3816, p3817);
module.exports.GetMatrixElements = p3818 => {
  var vLN0556 = 0;
  var vP3818 = p3818;
  var v3778 = Math.cos(vLN0556 / 2);
  var v3779 = Math.cos(vP3818 / 2);
  var v3780 = Math.cos(0);
  var v3781 = Math.sin(vLN0556 / 2);
  var v3782 = Math.sin(vP3818 / 2);
  var v3783 = Math.sin(vP3818 / 3);
  var vLN0557 = 0;
  var v3784 = v3778 * v3782 * v3780 - v3781 * v3779 * v3783;
  var vLN0558 = 0;
  var v3785 = v3778 * v3779 * v3780 - v3781 * v3782 * v3783;
  var v3786 = vLN0557 + vLN0557;
  var v3787 = v3784 + v3784;
  var v3788 = vLN0558 + vLN0558;
  var v3789 = vLN0557 * v3786;
  var v3790 = vLN0557 * v3787;
  var v3791 = vLN0557 * v3788;
  var v3792 = v3784 * v3787;
  var v3793 = v3784 * v3788;
  var v3794 = vLN0558 * v3788;
  var v3795 = v3785 * v3786;
  var v3796 = v3785 * v3787;
  var v3797 = v3785 * v3788;
  var vLN151 = 1;
  var vLN152 = 1;
  var vLN153 = 1;
  let vA203 = [];
  vA203[0] = (1 - (v3792 + v3794)) * vLN151;
  vA203[1] = (v3790 + v3797) * vLN151;
  vA203[2] = (v3791 - v3796) * vLN151;
  vA203[4] = (v3790 - v3797) * vLN152;
  vA203[5] = (1 - (v3789 + v3794)) * vLN152;
  vA203[6] = (v3793 + v3795) * vLN152;
  vA203[8] = (v3791 + v3796) * vLN153;
  vA203[9] = (v3793 - v3795) * vLN153;
  vA203[10] = (1 - (v3789 + v3792)) * vLN153;
  return vA203;
};
module.exports.GetRampAngle = p3819 => {
  switch (p3819.dir) {
    case 0:
    case Math.PI:
      return Math.atan(p3819.height / p3819.width) * 57.29577951308232;
    case Math.PI / 2:
    case Math.PI * 1.5:
      return Math.atan(p3819.height / p3819.length) * 57.29577951308232;
  }
};
module.exports.validateKey = (p3820, p3821) => module.exports.isString(p3820) && module.exports.isString(p3821) && p3820.replace(/\n|\r/g, "") == p3821.replace(/\n|\r/g, "");
module.exports.parseGUIs = (p3822, p3823) => {
  var v3798;
  var vA204 = [];
  for (var vLN0559 = 0; vLN0559 < p3822.length; vLN0559++) {
    v3798 = {
      ...p3822[vLN0559]
    };
    v3798.t = module.exports.limitMM(parseInt(v3798.t) || 0, 0, config.custGUITypes.length - 1);
    v3798.vt = module.exports.limitMM(parseInt(v3798.vt) || 0, 0, config.inputTypesGUI.length - 1);
    v3798.w = module.exports.limitMM(parseInt(v3798.w) || 0, 0, 2000);
    v3798.h = module.exports.limitMM(parseInt(v3798.h) || 0, 0, 2000);
    v3798.x = module.exports.limitMM(parseInt(v3798.x) || 0, 0, 100);
    v3798.y = module.exports.limitMM(parseInt(v3798.y) || 0, 0, 100);
    v3798.z = module.exports.limitMM(parseInt(v3798.z) || 0, 0, 2000);
    v3798.id = module.exports.limitMM(parseInt(v3798.id) || 0, 0, 2000);
    v3798.f = module.exports.limitMM(parseInt(v3798.f) || 10, 1, 100);
    v3798.o = module.exports.limitMM(parseFloat(v3798.o) || 1, 0, 1);
    v3798.nv = ~~!!parseInt(v3798.nv);
    v3798.v = (v3798.v || "").toString().replace(/[^\w\:\;\(\)\?\,\.\|\[\] \-\+*\$\@\=\^!{}\\]+/gmi, "");
    v3798.s = (v3798.s || "").toString().replace(/[^\w\:\;\(\)\?\,\.\|\[\] \-\+*\$\@\=\^!{}\\]+/gmi, "");
    v3798.lbl = (v3798.lbl || "").toString().replace(/[^\w\s]+/gmi, "");
    v3798.c = module.exports.isHexColor(v3798.c) ? v3798.c : "#ff0000";
    v3798.v = v3798.vt == 0 ? (v3798.v || "").toString().replace(/[^\w\:\;\(\)\?\,\.\|\[\] \-\+*\$\@\=\^!{}\\]+/gmi, "") : (v3798.v || "").toString().replace(/[^a-z0-9_]+/gmi, "");
    delete v3798.pv;
    if (!p3823) {
      if (v3798.t == 0) {
        delete v3798.f;
        delete v3798.v;
      } else if (v3798.t == 1 || v3798.t == 3) {
        delete v3798.s;
      } else if (v3798.t == 2) {
        delete v3798.f;
        delete v3798.v;
        delete v3798.c;
      }
      if (v3798.t == 0) {
        delete v3798.t;
      }
      if (v3798.z == 0) {
        delete v3798.z;
      }
      if (v3798.f == 10) {
        delete v3798.f;
      }
      if (v3798.id == 0) {
        delete v3798.id;
      }
      if (v3798.vt == 0) {
        delete v3798.vt;
      }
      if (v3798.c == "#ff0000" || v3798.c == "#FF0000") {
        delete v3798.c;
      }
      if (!v3798.s || !v3798.s.length) {
        delete v3798.s;
      }
      if (!v3798.v || !v3798.v.length) {
        delete v3798.v;
      }
      if (!v3798.lbl || !v3798.lbl.length) {
        delete v3798.lbl;
      }
    }
    vA204.push(v3798);
  }
  return vA204;
};
module.exports.getRegionInfo = (p3824, p3825) => {
  var vA205 = ["UNKNOWN", "OC", "AS", "EU", "NA", "SA"];
  for (let v3799 in p3825) {
    if (p3825[v3799].regionIds.indexOf(p3824) != -1) {
      return [v3799, vA205[config.regionIND[v3799]]];
    }
  }
  return [0, 0];
};
module.exports.getRegionName = (p3826, p3827) => {
  for (let v3800 in p3827) {
    if (p3827[v3800].regionIds.indexOf(p3826) != -1) {
      return p3827[v3800].abbreviation.toUpperCase();
    }
  }
  return null;
};
module.exports.b64e = p3828 => Buffer.from(p3828, "utf8").toString("base64");
module.exports.b64d = p3829 => Buffer.from(p3829, "base64").toString("ascii");
module.exports.b64Test = p3830 => /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/.test(p3830);
Date.prototype.getWeek = function () {
  var v3801 = new Date(this.getTime());
  v3801.setUTCHours(0, 0, 0, 0);
  v3801.setUTCDate(v3801.getUTCDate() + 3 - (v3801.getUTCDay() + 6) % 7);
  var v3802 = new Date(Date.UTC(v3801.getUTCFullYear(), 0, 4));
  return 1 + Math.round(((v3801.getTime() - v3802.getTime()) / 86400000 - 3 + (v3802.getUTCDay() + 6) % 7) / 7);
};
module.exports.dayInWeek = (p3831, p3832) => {
  var v3803 = new Date();
  v3803.setUTCDate(v3803.getUTCDate());
  var v3804 = p3831.indexOf(v3803.getUTCDay());
  var v3805 = v3803.getWeek();
  var v3806 = p3832 ? v3805 & 1 : !(v3805 & 1);
  if (v3804 > -1 && v3806) {
    return true;
    var v3807 = new Date(v3803);
  }
  return false;
};
module.exports.isKRSale = () => module.exports.dayInWeek([6, 0], true);
module.exports.isDoubleClassXP = () => module.exports.dayInWeek([6, 0], false);
module.exports.getDropsTime = p3833 => {
  p3833 = p3833 == null ? module.exports.getCurrentDropId() : p3833;
  var v3808 = config.twitchEvents[p3833];
  var v3809 = new Date(v3808.time.start).getTime() - Date.now();
  var v3810 = new Date(v3808.time.end).getTime() - Date.now();
  var v3811 = v3808.revealGrace || 259200000;
  return [v3809, v3810, !(v3809 > v3811) && !(v3810 <= 0), p3833];
};
module.exports.getCurrentDropId = () => {
  for (var vLN0560 = 0; vLN0560 < config.twitchEvents.length; vLN0560++) {
    var v3812 = config.twitchEvents[vLN0560];
    var v3813 = new Date(v3812.time.start).getTime() - Date.now();
    var v3814 = new Date(v3812.time.end).getTime() - Date.now();
    var v3815 = v3812.revealGrace || 259200000;
    var v3816 = !(v3813 > v3815) && !(v3814 <= 0);
    if (v3816) {
      return vLN0560;
    }
  }
  return 0;
};
module.exports.compareVal = (p3834, p3835, p3836) => p3834 == 0 ? p3835 == p3836 : p3834 == 1 ? p3835 != p3836 : p3834 == 2 ? p3835 > p3836 : p3834 == 3 ? p3835 >= p3836 : p3834 == 4 ? p3835 < p3836 : p3834 != 5 || p3835 <= p3836;
module.exports.decodeStats = p3837 => {
  var vO110 = {};
  for (var v3817 = p3837.split("|"), vLN0561 = 0; vLN0561 < v3817.length; vLN0561++) {
    var v3818 = v3817[vLN0561].split(",");
    var v3819 = v3818[0];
    vO110[v3819] = {};
    for (var vLN154 = 1; vLN154 < v3818.length; vLN154++) {
      var [v3820, v3821] = v3818[vLN154].split(":");
      vO110[v3819][v3820] = parseFloat(v3821);
    }
  }
  return vO110;
};
module.exports.encodeStats = p3838 => {
  var vA206 = [];
  for (var v3822 in p3838) {
    var vA207 = [v3822];
    for (var v3823 in p3838[v3822]) {
      vA207.push(v3823 + ":" + p3838[v3822][v3823]);
    }
    vA206.push(vA207.join(","));
  }
  return vA206.join("|");
};
module.exports.arrayChunk = (p3839, p3840) => Array.from({
  length: Math.ceil(p3839.length / p3840)
}, (p3841, p3842) => p3839.slice(p3842 * p3840, p3842 * p3840 + p3840));
module.exports.weightedRandom = p3843 => {
  let v3824;
  let vLN0562 = 0;
  let v3825 = Math.random();
  for (v3824 in p3843) {
    vLN0562 += p3843[v3824];
    if (v3825 <= vLN0562) {
      return v3824;
    }
  }
};
var v3826 = Object.prototype.hasOwnProperty;
module.exports.hasProp = (p3844, p3845) => {
  try {
    return v3826.call(p3844, p3845);
  } catch (e23) {
    return false;
  }
};
var v3827 = String.prototype.match;
module.exports.match = (p3846, p3847) => v3827.call(p3846, p3847);
var v3828 = String.prototype.split;
module.exports.split = (p3848, p3849) => v3828.call(p3848, p3849);
module.exports.toLower = p3850 => (p3850 || "").toString().toLowerCase();
module.exports.toUpper = p3851 => (p3851 || "").toString().toUpperCase();
var v3829 = typeof Storage != "undefined";
module.exports.saveVal = (p3852, p3853) => {
  if (v3829) {
    localStorage.setItem(p3852, p3853);
  }
};
module.exports.deleteVal = p3854 => {
  if (v3829) {
    localStorage.removeItem(p3854);
  }
};
module.exports.getSavedVal = p3855 => v3829 ? localStorage.getItem(p3855) : null;
module.exports.hasSavedVal = p3856 => !!v3829 && localStorage.hasOwnProperty(p3856);
module.exports.cssCheck = p3857 => {
  if (!p3857 || !module.exports.isString(p3857)) {
    return true;
  }
  for (var vP3857 = p3857, v3830 = /\\|'|"|`/gim; v3830.test(vP3857);) {
    vP3857 = vP3857.replace(v3830, "");
  }
  vP3857 = vP3857.replace(/important/gmi, "REPLACE_IMP");
  var v3831 = /import|canvas|url|expression|behavior|-moz-binding|javascript|exec/gim.test(vP3857);
  return !v3831 && (vP3857 = vP3857.replace(/REPLACE_IMP/gmi, "important"), vP3857);
};
module.exports.captchaPromise = (p3858, p3859) => new Promise((p3860, p3861) => {
  if (window.hcaptcha.ranOnce) {
    window.hcaptcha.remove();
  }
  p3859 = p3859 || {};
  p3859.sitekey = config.hcaptchaKey;
  p3859.size = "invisible";
  p3859.callback = p3862 => {
    console.log("SUCCESS", p3862);
    p3860(p3862);
  };
  p3859["error-callback"] = p3863 => {
    console.log("error", p3863);
    p3861(p3863);
  };
  p3859["close-callback"] = p3864 => {
    console.log("close", p3864);
    p3861(p3864);
  };
  window.hcaptcha.render(p3858 || "hCap", p3859);
  window.hcaptcha.execute();
  window.hcaptcha.ranOnce = true;
});
module.exports.toKeyCode = p3865 => typeof p3865 == "string" ? p3865.toUpperCase().charCodeAt(0) : p3865;
function f501(p3866) {
  if (!p3866 || typeof p3866 != "object") {
    return p3866;
  }
  var vO111 = {};
  for (var v3832 in p3866) {
    var v3833 = p3866[v3832];
    switch (true) {
      case v3833 instanceof Date:
        var v3834 = new Date();
        v3834.setDate(v3833.getDate());
        vO111[v3832] = v3834;
        break;
      case v3833 instanceof Function:
        vO111[v3832] = p3866[v3832];
        break;
      case v3833 instanceof Array:
        var vA208 = [];
        for (var v3836 of v3833) {
          vA208.push(f501(v3836));
        }
        vO111[v3832] = vA208;
        break;
      case v3833 instanceof Object:
        var vO112 = {};
        for (var v3836 in v3833) {
          vO112[v3836] = f501(v3833[v3836]);
        }
        vO111[v3832] = vO112;
        break;
      default:
        vO111[v3832] = p3866[v3832];
    }
  }
  return vO111;
}
function f502(p3867) {
  let vO113 = {};
  Object.keys(p3867).map(p3868 => {
    vO113[p3868] = Array.isArray(p3867[p3868]) ? [].concat(p3867[p3868]) : typeof p3867[p3868] == "object" ? f502(p3867[p3868]) : p3867[p3868];
  });
  return vO113;
}
module.exports.deepCopy = p3869 => typeof p3869 == "object" ? Array.isArray(p3869) ? [...p3869].map(f501) : f501(p3869) : p3869;
module.exports.superClone = p3870 => typeof p3870 == "object" ? Array.isArray(p3870) ? [...p3870].map(f502) : f502(p3870) : p3870;
module.exports.logStringify = p3871 => typeof p3871 == "object" ? JSON.stringify(p3871, null, 2) : p3871 + "";
module.exports.toRoundArray = (p3872, p3873 = [], p3874 = 0) => {
  p3873[p3874] = Math.round(parseFloat(p3872.x) || 0);
  p3873[p3874 + 1] = Math.round(parseFloat(p3872.y) || 0);
  p3873[p3874 + 2] = Math.round(parseFloat(p3872.z) || 0);
  return p3873;
};
module.exports.triToJSON = p3875 => {
  const vO114 = {
    isTri: p3875.isTri,
    tris: [...p3875.a.toArray(), ...p3875.b.toArray(), ...p3875.c.toArray()],
    minMax: [p3875.minX, p3875.minY, p3875.minZ, p3875.maxX, p3875.maxY, p3875.maxZ]
  };
  return vO114;
};
module.exports.convertInv = p3876 => {
  var vA209 = [];
  for (var vLN0563 = 0; vLN0563 < p3876.length; vLN0563++) {
    vA209.push({
      ind: p3876[vLN0563].i,
      cnt: p3876[vLN0563].c
    });
  }
  return vA209;
};
module.exports.fixIP = p3877 => (p3877 + "").replace(/:/g, "");
module.exports.parseJson = p3878 => {
  try {
    var v3837 = JSON.parse(p3878);
    return v3837;
  } catch (e24) {
    return {};
  }
};
const vA210 = [];
for (let vLN0564 = 0; vLN0564 < 256; vLN0564++) {
  vA210[vLN0564] = (vLN0564 < 16 ? "0" : "") + vLN0564.toString(16);
}
module.exports.generateUUID = () => {
  const v3838 = Math.random() * 4294967295 | 0;
  const v3839 = Math.random() * 4294967295 | 0;
  const v3840 = Math.random() * 4294967295 | 0;
  const v3841 = Math.random() * 4294967295 | 0;
  const v3842 = vA210[v3838 & 255] + vA210[v3838 >> 8 & 255] + vA210[v3838 >> 16 & 255] + vA210[v3838 >> 24 & 255] + "-" + vA210[v3839 & 255] + vA210[v3839 >> 8 & 255] + "-" + vA210[v3839 >> 16 & 15 | 64] + vA210[v3839 >> 24 & 255] + "-" + vA210[v3840 & 63 | 128] + vA210[v3840 >> 8 & 255] + "-" + vA210[v3840 >> 16 & 255] + vA210[v3840 >> 24 & 255] + vA210[v3841 & 255] + vA210[v3841 >> 8 & 255] + vA210[v3841 >> 16 & 255] + vA210[v3841 >> 24 & 255];
  return v3842.toLowerCase();
};
module.exports.isMatchingGameVersion = p3879 => p3879 === version;
module.exports.removeNFT = function (p3880) {
  p3880.rarities[7].name = "External";
  p3880.skins.forEach(p3881 => {
    if (p3881.limT == "NFT") {
      p3881.limT = "External";
    }
  });
  p3880.tags.External = p3880.tags.NFT;
  delete p3880.tags.NFT;
};
module.exports.getAssetData = p3882 => {
  var vO115 = {};
  try {
    vO115 = JSON.parse(p3882);
  } catch (e25) {}
  return vO115;
};
module.exports.hasActiveEvents = () => {
  let v3843 = false;
  let now = Date.now();
  for (let vLN0565 = 0; vLN0565 < config.events.length; vLN0565++) {
    if (now >= new Date(config.events[vLN0565].start).getTime() && now <= new Date(config.events[vLN0565].end).getTime()) {
      v3843 = true;
      break;
    }
  }
  return v3843;
};
module.exports.getActiveEvent = p3883 => {
  var v3845 = config.events.find(p3884 => p3884.id == p3883);
  if (v3845) {
    return v3845;
  }
  let now = Date.now();
  for (var vLN0566 = 0; vLN0566 < config.events.length; vLN0566++) {
    v3845 = config.events[vLN0566];
    if (v3845.reveal) {
      var v3847 = new Date(v3845.start).getTime() - now;
      var v3848 = new Date(v3845.end).getTime() - now;
      if (v3848 > 0 && v3847 <= v3845.reveal) {
        return v3845;
      }
    }
  }
  return null;
};
module.exports.getImagesPromises = p3885 => Promise.all(p3885.map(p3886 => new Promise(function (p3887) {
  var v3849 = new Image();
  v3849.onload = () => {
    p3887(p3886);
  };
  v3849.onerror = () => {
    p3887(p3886);
  };
  v3849.srcset = v3849.src = p3886;
})));
module.exports.sleep = p3888 => new Promise(p3889 => requestAnimationFrame(p3889, p3888));
module.exports.isTransTex = p3890 => (p3890 + "").toLowerCase().startsWith("link_");
module.exports.sanitizeHTML = p3891 => {
  const v3850 = document.createElement("span");
  v3850.textContent = p3891;
  return v3850.innerHTML;
};
module.exports.maskEmail = p3892 => (p3892 + "").replace(/(\w{1})[\w.-]+@([\w.]+\w)/, "$1***@$2");
module.exports.formatBytes = (p3893, p3894 = 2) => {
  if (!+p3893) {
    return "0B";
  }
  const v3851 = p3894 < 0 ? 0 : p3894;
  const v3852 = Math.floor(Math.log(p3893) / Math.log(1000));
  return "" + parseFloat((p3893 / Math.pow(1000, v3852)).toFixed(v3851)) + ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"][v3852];
};